import Vue from 'vue'
import Router from 'vue-router'
import StepOne from '@/components/StepOne'
import StepTwo from '@/components/StepTwo'
import Test from '@/components/Test'
import TestAdult from '@/components/TestAdult'
import Preoloader from '@/components/Preloader'
import Result from '@/components/Result'

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'StepOne',
            component: StepOne
        },
        {
            path: '/step-two/:langId/:catId',
            name: 'StepTwo',
            component: StepTwo
        },
        {
            path: '/test',
            name: 'Test',
            component: Test
        },
        {
            path: '/test-adult',
            name: 'TestAdult',
            component: TestAdult
        },
        {
            path: '/preloader',
            name: 'Preloader',
            component: Preoloader
        },
        {
            path: '/result',
            name: 'Result',
            component: Result
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js